
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.247 10.704l.007.008.627.748.596-.64.348-.374 2.951-3.171a.746.746 0 00.186-.503.743.743 0 00-.195-.5.644.644 0 00-.464-.21.643.643 0 00-.469.2L8.556 8.71V1.367a.743.743 0 00-.2-.496.644.644 0 00-.467-.204.644.644 0 00-.466.204.743.743 0 00-.2.496v7.166L5.115 6.02a.648.648 0 00-.459-.227.64.64 0 00-.475.183.738.738 0 00-.22.488.75.75 0 00.163.514l3.122 3.727zm6.813 3.189c-.334 0-.174 0-.606.007H2.263c-.144-.008-.163 0-.324 0a.56.56 0 00-.428.186.696.696 0 00-.178.47v.007c0 .366.271.663.606.663H14.06c.335 0 .606-.297.606-.663v-.008c0-.366-.27-.662-.605-.662z"}})])
          )
        }
      }
    